module.exports = "<div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Ship to Address ID:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- cadShipAddressId %} </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/facilities/html/rmsShipToAddressId.html
// module id = 1307
// module chunks = 1